module.exports = __webpack_public_path__ + "static/img/C (22).c35a0ccb.png";